/* eslint-disable */
/**
 * ℹ️ Код этого класса — "copy-paste" класса CSS2DRenderer из ThreeJS c несколькими изменениями.
 * Сделанные изменения описаны ниже по коду.
 * Код оригинального класса: https://github.com/mrdoob/three.js/blob/e1ead8c5c2eb2395942f5e7d9af7240befc5d729/examples/jsm/renderers/CSS2DRenderer.js
 */

import { Matrix4, Object3D, Vector3 } from 'three';
import * as THREE from 'three';

class CSS2DObject extends Object3D {
  constructor(element = document.createElement('div')) {
    super();

    this.element = element;

    this.element.style.position = 'absolute';
    this.element.style.userSelect = 'none';

    this.element.setAttribute('draggable', false);

    this.addEventListener('removed', function () {
      this.traverse(function (object) {
        if (object.element instanceof Element && object.element.parentNode !== null) {
          object.element.parentNode.removeChild(object.element);
        }
      });
    });
  }

  copy(source, recursive) {
    super.copy(source, recursive);

    this.element = source.element.cloneNode(true);

    return this;
  }
}

CSS2DObject.prototype.isCSS2DObject = true;

//

const _vector = new Vector3();
const _viewMatrix = new Matrix4();
const _viewProjectionMatrix = new Matrix4();
const _a = new Vector3();
const _b = new Vector3();

class CSS2DRenderer {
  constructor(parameters = {}) {
    const _this = this;

    let _width, _height;
    let _widthHalf, _heightHalf;

    const cache = {
      objects: new WeakMap(),
    };

    const domElement =
      parameters.element !== undefined ? parameters.element : document.createElement('div');

    domElement.style.overflow = 'hidden';

    this.domElement = domElement;

    this.getSize = function () {
      return {
        width: _width,
        height: _height,
      };
    };

    this.render = function (scene, camera) {
      if (scene.autoUpdate === true) scene.updateMatrixWorld();
      if (camera.parent === null) camera.updateMatrixWorld();

      _viewMatrix.copy(camera.matrixWorldInverse);
      _viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, _viewMatrix);

      renderObject(scene, scene, camera);
      zOrder(scene);
    };

    this.setSize = function (width, height) {
      _width = width;
      _height = height;

      _widthHalf = _width / 2;
      _heightHalf = _height / 2;

      domElement.style.width = width + 'px';
      domElement.style.height = height + 'px';
    };

    function renderObject(object, scene, camera) {
      if (object.isCSS2DObject) {
        object.onBeforeRender(_this, scene, camera);

        _vector.setFromMatrixPosition(object.matrixWorld);
        _vector.applyMatrix4(_viewProjectionMatrix);

        const { element, style: additionalStyle } = object;

        /**
         * ✅ Изменение №1
         * В мобильных браузерах на iOS координаты объекта округлялись до целых чисел.
         * Это создавало неприятный эффект "дрибезжания" при взаимодействии с картой.
         * Поэтому это условие было удалено.
         */

        const translateX = _vector.x * _widthHalf + _widthHalf;
        const translateY = -_vector.y * _heightHalf + _heightHalf;

        element.style.transform = `translate(-50%, -50%) translate(${translateX}px, ${translateY}px)`;

        /**
         * Добавилась возможность прокидывать дополнительные стили для объекта
         */
        for (const [key, value] of Object.entries(additionalStyle)) {
          if (key === 'transform') {
            element.style.transform = element.style.transform + ' ' + value;
          } else {
            element.style[key] = value;
          }
        }

        element.style.display = object.visible && _vector.z >= -1 && _vector.z <= 1 ? '' : 'none';

        const objectData = {
          distanceToCameraSquared: getDistanceToSquared(camera, object),
        };

        cache.objects.set(object, objectData);

        if (element.parentNode !== domElement) {
          domElement.appendChild(element);
        }

        object.onAfterRender(_this, scene, camera);
      }

      for (let i = 0, l = object.children.length; i < l; i++) {
        renderObject(object.children[i], scene, camera);
      }
    }

    function getDistanceToSquared(camera, object) {
      /**
       * ✅ Изменение №2
       * Так как Mapbox Custom Layer работает с Projection Matrix, позиция ThreeJS камеры не обновляется.
       * Поэтому изначальный метод, который рассчитывал расстояние от камеры до объекта
       * на основании "matrixWorld", работал неправильно (matrixWorld, как и position, тоже не обновляется).
       * С позицией объекта на сцене все хорошо, а позиция камеры определяется из инвертированной "projectionMatrix".
       */

      const cameraProjectionMatrixInversed = new THREE.Matrix4()
        .copy(camera.projectionMatrix)
        .invert();
      const cameraPosition = new THREE.Vector3().applyMatrix4(cameraProjectionMatrixInversed);

      _a.copy(cameraPosition);

      _b.setFromMatrixPosition(object.matrixWorld);

      return _a.distanceToSquared(_b);
    }

    function filterAndFlatten(scene) {
      const result = [];

      scene.traverse(function (object) {
        if (object.isCSS2DObject) result.push(object);
      });

      return result;
    }

    function zOrder(scene) {
      const sorted = filterAndFlatten(scene).sort(function (a, b) {
        const distanceA = cache.objects.get(a).distanceToCameraSquared;
        const distanceB = cache.objects.get(b).distanceToCameraSquared;

        return distanceA - distanceB;
      });

      const zMax = sorted.length;

      for (let i = 0, l = sorted.length; i < l; i++) {
        sorted[i].element.style.zIndex = zMax - i;
      }
    }
  }
}

export { CSS2DObject, CSS2DRenderer };
